<div class="bg-white">
  <hr />
  <p-menu #menu [model]="items" [popup]="true" styleClass="w-full"></p-menu>
  <div class="py-3 px-4 flex items-center hover:cursor-pointer" (click)="menu.toggle($event)">
      <i class="pi pi-user mr-2"></i>
      <p>{{userName}}</p>
      <i class="pi pi-chevron-up ml-auto"></i>
  </div>
</div>
